import { useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useDispatch, useSelector } from "react-redux";
import { getPatientNotification } from "../../actions/dashboardAction";
import {
  acceptOrRejectPatient,
  getPatients,
  getPendingRequests,
} from "../../actions/patientAction";
import Avatar from "../../assets/images/default-avatar.jpg";
import history from "../../utils/history";
import { BUCKET_NAME } from "../../constants/states";
import { formatDate } from "../../utils/helper";
const PendingList = () => {
  const pendingPatientList = useSelector(
    (state) => state.patient.pendingPatientList
  );

  const role = useSelector((state) => state.role.role);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPendingRequests());
  }, [dispatch]);

  const tooglepatient = (actionName, id) => {
    dispatch(
      acceptOrRejectPatient(actionName, id, () => {
        dispatch(getPendingRequests());
        dispatch(getPatients());
        dispatch(getPatientNotification(role.val));
      })
    );
  };

  const patientAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div className="action-btn-wrapper row">
          <button
            className="btn-orange btn-table "
            onClick={() => {
              tooglepatient("practitionerAcceptPatient", row.ID);
            }}
          >
            Accept
          </button>

          <button
            className=" btn-orange btn-black  btn-table "
            onClick={() => {
              tooglepatient("practitionerRejectsPatient", row.ID);
            }}
          >
            Reject
          </button>
        </div>
      </>
    );
  };

  const profileAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <button
        className="profile-icon"
        onClick={() => {
          history.push("/app/patient/info", row.ID);
        }}
      >
        <img
          src={
            row.Has_Profile_Picture
              ? `https://storage.googleapis.com/${BUCKET_NAME}/user/${
                  row.user_id
                }.png?${Math.random()}`
              : Avatar
          }
          alt="icon"
        />{" "}
        <span>View</span>
      </button>
    );
  };

  const columns = [
    {
      dataField: "ID",
      text: "Profile",
      sort: false,
      headerStyle: {
        width: "100px",
      },
      formatter: profileAction,
    },
    {
      dataField: "first_name",
      text: "First Name",
      sort: true,
    },
    {
      dataField: "last_name",
      text: "Last Name",
      sort: true,
    },
    {
      dataField: "requested_date",
      text: "Date Requested",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return formatDate(row.requested_date);
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: patientAction,
    },
  ];

  return (
    <div>
      <p className="page-desc">
        Find Patients by Name, Nickname, or Email Address. Create prescriptions
        or view prescription history.
      </p>
      <h5 className="profile-title mb-1">Pending Requests</h5>
      {pendingPatientList.length > 0 ? (
        <BootstrapTable
          classes="react-bootstrap-table"
          keyField="ID"
          columns={columns}
          data={pendingPatientList}
          headerClasses="header-class"
        />
      ) : (
        <p className="page-desc">
          There are no pending patient requests at this time
        </p>
      )}
    </div>
  );
};

export default PendingList;
